import React from 'react';

import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { useCruiseShips } from '~/components/Cruises/context/useCruiseShips';

import useAppNavigation from '~/hooks/useAppNavigation';

const columns: Array<GridColDef> = [
  {
    field: 'id',
    headerName: 'Id',
    width: 350,
    display: 'flex',
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    display: 'flex',
  },
];

export default function ShipList() {
  const { ships, page, total, shipsPerPage, paginate, isLoading } = useCruiseShips();
  const { push } = useAppNavigation();

  return (
    <DataGrid
      loading={isLoading}
      columns={columns}
      rows={ships ?? []}
      rowCount={total}
      pageSizeOptions={[shipsPerPage]}
      paginationMode="server"
      paginationModel={{ page: page - 1, pageSize: shipsPerPage }}
      onPaginationModelChange={({ page }) => paginate(page + 1)}
      onRowClick={(params) => push(`/cruises/ships/${params.row.id}/images`)}
      autoHeight
      disableColumnFilter
      disableColumnMenu
    />
  );
}
